import React from "react";
import { Button, Row } from "reactstrap";
import ItemCounter from "../ItemCounter";

const OfferFooter = ({
  darkMode,
  color,
  totalPrice,
  selectedItemsSize,
  setSelectedItemsSize,
  currency,
  addToCart,
  loader,
}) => (
  <Row className="mx-2 mb-5 mt-4 d-flex flex-column justify-content-center align-items-center">
    <ItemCounter
      selectedItem={selectedItemsSize}
      setSelectedItemsSize={(quantity) =>
        setSelectedItemsSize((prev) => ({ ...prev, quantity }))
      }
    />
    <Button
      style={{ background: `${color}` }}
      className="top_cards__addtocart fs--16 fw--400 my-4 w-100"
      onClick={addToCart}
      disabled={loader}
    >
      Add to cart {currency || "$"} {totalPrice.toFixed(2)}
    </Button>
  </Row>
);

export default OfferFooter;
